import { DialogProps } from "@mui/material";
import AppButton from "../../components/AppButton";
import { FormattedMessage } from "react-intl";
import ResponsiveDialog from "../../components/ResponsiveDialog";
import { formInputsStyles, SX_FORM_CANCEL, SX_FORM_SUBMIT } from "../styles";

interface Props extends DialogProps {
  onClose: () => void;
  onSubmit: () => void;
  disabled: boolean;
  title: string;
}

export default function BusinessRuleResponsiveModal({
  children,
  disabled,
  onClose,
  onSubmit,
  open,
  title,
}: Props) {
  const { classes } = formInputsStyles();

  return (
    <ResponsiveDialog
      classes={classes.paper}
      crossIcon
      onClose={onClose}
      open={open}
      fullWidth={true}
      title={title}
      actions={
        <>
          <AppButton intent="tonal" onClick={onClose} sx={SX_FORM_CANCEL}>
            <FormattedMessage id="CANCEL" />
          </AppButton>
          <AppButton disabled={disabled} onClick={onSubmit} sx={SX_FORM_SUBMIT}>
            <span>
              <FormattedMessage id="SUBMIT" />
            </span>
          </AppButton>
        </>
      }
    >
      {children}
    </ResponsiveDialog>
  );
}
